import CreateMap from "../../../../components/DataCollection/Unifier/Maps/CreateMap/CreateMap"


const CreateMapScreen = () => {
  return (
    <CreateMap/>
  )
}

export default CreateMapScreen